import muiTheme from './muiTheme';

const setTheme = (tenant) => {
  let customTheme = muiTheme;
  const { theme } = tenant;
  const defaultBlack = '#030507';
  const defaultGray = '#727476';

  const { enabled, primaryColor, secondaryColor } = theme;

  if (enabled) {
    // Update custom theme with tenant colors
    customTheme = {
      ...muiTheme,
      overrides: {
        ...muiTheme.overrides,
        MuiSnackbarContent: {
          root: {
            fontFamily: 'Heebo, sans-serif',
            backgroundColor: primaryColor,
          },
        },
      },
      palette: {
        ...muiTheme.palette,
        primary: {
          ...muiTheme.palette.primary,
          main: primaryColor,
          A700: primaryColor, // update active field hint text color
        },
        secondary: {
          ...muiTheme.palette.secondary,
          main: secondaryColor,
        },
      },
    };

    // Inject custom stylesheet
    const css = `
      .grey-section-full {
        background-color: #f7f7f7;
      }

      .transparent-link:hover {
        border-bottom: 1px solid ${primaryColor};
      }

      .account.active-link {
        border-bottom: 1px solid ${defaultBlack};
      }

      .text-block-4-copy,
      .breadcrumb-link {
        color: ${defaultBlack};
      }

      .breadcrumb-link:hover {
        border-bottom: 1px solid ${defaultBlack};
        color: ${defaultBlack};
      }

      .breadcrumb-link.w--current {
        border-bottom-color: transparent;
        color: ${defaultBlack};
      }

      .breadcrumb-link.active-page {
        border-bottom-style: none;
        border-bottom-color: ${defaultBlack};
        color: ${defaultBlack};
      }

      .nav-link:hover,
      .nav-link.w--current {
        border-bottom: 1px solid ${primaryColor};
      }

      .text-subsector-label,
      .text-target-raise,
      .card-navy-detail,
      .team-name,
      .btn-download,
      ._1st-header,
      ._2nd-header-copy,
      .black-44,
      ._26-black,
      .register-link,
      .forgot-pw-link,
      .advanced-label span,
      
      .stepper--header__title {
        color: ${secondaryColor};
      }

      .stepper--header__close--button {
        border: 2px solid ${secondaryColor};
        color: ${secondaryColor};
      }
     
      .btn-download:hover {
        border-bottom-color: ${secondaryColor};
        background-color: transparent;
        color: ${secondaryColor};
      }

      ._16-black-label,
      .sub-header,
      .faq-question,
      ._13-black-label {
        color: ${defaultGray};
      }

      ._2nd-nav-link:hover {
        border-bottom: 1px solid ${primaryColor};
      }

      ._2nd-nav-link.w--current {
        border-bottom-color: ${primaryColor};
      }
      .pre-title,
      ._2nd-nav-link.active-link {
        border-bottom-color: ${primaryColor};
        color: ${primaryColor};
      }

      .comment-box .single-comment-box .text-holder h6{
        color: ${primaryColor} !important;
      }

      .text-placard,
      .action-button-comment,
      
      .action-button {
        background-color: ${primaryColor} !important;
      }
      .underline{
        text-decoration-line: line-through !important;
        text-decoration-thickness: 4px;
      }
      .investment-button {
        background-color: ${primaryColor} !important;
        padding: 10px;
        color: white;
      }
      .active-tab {
        color: ${primaryColor};
        border-bottom: 1px solid ${primaryColor};
      }
      .navbar.anon-navbar .navbar-login a:nth-child(2){
        color: ${primaryColor} !important;
        border-color: ${primaryColor};
        outline: none; 
        border-radius: 4px;
        margin-right: 1rem;
        padding: 16px 20px !important;
      }
    
      .navbar.anon-navbar .navbar-login a:nth-child(2):hover{
        transition: all 0.3s;
        color: #fff !important;
        background-color: ${primaryColor};
        outline: none; 
        border-radius: 4px;
        margin-right: 1rem;
        padding: 16px 20px !important;
      }
      .navbar.anon-navbar .navbar-login a:nth-child(1){
        color: white !important;
        border-color: ${primaryColor};
        outline: none; 
        border-radius: 4px;
        margin-right: 1rem;
        padding: 16px 20px !important;
      }
      
      .clear-button {
        color: ${secondaryColor} !important;
      }

      .button.small {
        border: 1px solid ${primaryColor};
        color: #fff;
      }

      .btn-small-outline {
        border: 1.3px solid ${primaryColor};
        color: ${primaryColor};
      }
      .offerboard-timeout-section .rightside-wrapper .clock-wrapper ul li small{
        color: ${primaryColor};
      }
      .button-2.no-align {
        border: 1px solid ${primaryColor};
        color: ${primaryColor};
      }
      .comment-box .single-comment-box .text-holder .reply-button button:hover{
        background-color: white!important;
        border: 1px solid ${primaryColor};
        color: ${primaryColor};
      }
      
      .button,
      .button-2,
      .button-2.no-align:hover,
      .button-inline,
      .button-modal,
      .snackbar, 
      .btn-small-outline:hover  {
        background-color: ${primaryColor};
      }
      .limit-info-container .popup_why > button,
      .limit-info-container > svg {
        background-color: ${primaryColor};
      }

      .limit-info-container .popup_why > button:hover,
      .limit-info-container  { 
        border: 2px solid ${primaryColor};
      }
 

      .button:hover,
      .button:focus,
      .square-paginiation.active,
      .button-inline:hover {
        background-color: ${secondaryColor};
      }

      .nav-link.dash-current-page,
      .invest-button,
      .text-block-3,
      .text-link {
        color: ${primaryColor};
      }

      .invest-button:hover {
        border-bottom: 1px solid ${primaryColor};
      }

      .btn-download {
        border: 1px none ${primaryColor};
      }

      .btn-cancel:hover {
        border-bottom-color: ${secondaryColor};
        color: ${secondaryColor};
      }

      .button-2.no-align {
        border: 1px solid ${primaryColor};
        color: ${primaryColor};
      }

      .offers-search-bar-small .search-offers,
      .offers-search-bar .search-offers { 
        border: 1px solid ${primaryColor};
        background: #FFFFFF; 
        box-sizing: border-box;
        border-radius: 4px;
        position: static;
        width: 230px;
        height: 46px;
        display: flex;
        justify-content: center;
  
      }
    `;

    const head = document.head || document.getElementsByTagName('head')[0];
    const style = document.createElement('style');

    head.appendChild(style);

    style.type = 'text/css';
    if (style.styleSheet) {
      // This is required for IE8 and below.
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
  }

  return customTheme;
};

export default setTheme;



// WEBPACK FOOTER //
// ./src/styles/setTheme.js